import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
//import Button from "../../components/Button";
import Button from "../../../components/Button";
import styled from "styled-components";
import "./styles.css"
import {isAdministrator} from "../../../utils/UserInfo";

const PreEExceptionConfirmationDialog = ({ title, header, body, cancelButton, acceptButton, editButton, deleteButton, onClose, viewOnly,
                         isCreatorAdminIntCont, isExternalContributor, editVisible, newFormSaveVisibleText,approvedStatus,isApproved,energized,waitingStatus }) => {
    //console.log('props,........isApproved', isApproved);
    //console.log('props,........energized', energized);
    return (
        <div className="preE-confirmation">
        <div className="preE-confirmation--toolbar">
        <div className="preE-confirmation--title">{title}</div>
        <div className="preE-confirmation--close"><FontAwesomeIcon icon={faTimes} size="lg" onClick={onClose}/></div>
    </div>
    <div className="preE-confirmation--header">
        {header}
        </div>
        <div className="preE-confirmation--body">
        {body}
        </div>
        <div className="preE-confirmation--footer">
        {((isCreatorAdminIntCont || isExternalContributor) && editVisible && !waitingStatus) &&
        <div className="preE-confirmation--footer-edit">
            <Button onClickHandler={editButton.action}>{editButton.label}</Button>
            </div>
        }
        {(((isCreatorAdminIntCont || isExternalContributor) && !editVisible) || ((isCreatorAdminIntCont || isExternalContributor) && newFormSaveVisibleText)) &&
        <div className="preE-confirmation--footer-save">
            <Button id= "preE-confirmation-save-button"  onClickHandler={acceptButton.action}>{acceptButton.label}</Button>
            </div>
        }

        <div className="preE-confirmation--footer-cancel">
                <Button id= "preE-confirmation-cancel-button"  onClickHandler={cancelButton.action}>{!editVisible ? 'Cancel' : cancelButton.label}</Button>
                </div>


        {(
            ((isCreatorAdminIntCont || isExternalContributor) && !editVisible && !newFormSaveVisibleText && !approvedStatus)
            ||
            (!editVisible && isAdministrator() && isApproved && energized !== 'Y')
        )
        &&
        <div className="preE-confirmation--footer-delete">
            <Button  id= "preE-confirmation-delete-button" onClickHandler={deleteButton.action}>{deleteButton.label}</Button>
            </div>
        }
</div>
    </div>
)
};

export default PreEExceptionConfirmationDialog;